import { treaty } from "@elysiajs/eden";
import type { App } from "@forge/api";
import { formatUnknownError } from "@forge/ui";

export const api = treaty<App>(
  import.meta.env.VITE_API_URL ?? "http://localhost:3000",
  { fetch: { credentials: "include" } },
);

type Success<T> = Exclude<NonNullable<T>, { error: string }>;

/**
 * Unwraps an Eden Treaty response, throwing on transport errors and on
 * `{ error }` bodies returned by API guards, so callers always get the
 * narrowed success type.
 */
export function unwrap<T, E>(response: { data: T; error: E }): Success<T> {
  if (response.error) {
    throw new Error(formatUnknownError(response.error) ?? "Falha na requisição");
  }
  const data = response.data as Record<string, unknown> | null;
  if (data && typeof data === "object" && typeof data.error === "string") {
    throw new Error(data.error);
  }
  return data as Success<T>;
}
